export const isObjectEmpty = (obj: Object): boolean => {
  if (obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  } else {
    return true;
  }
};
